import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import Amplify from "aws-amplify";
import devConfig from "./aws-config/aws-exports";
import prodConfig from "./aws-config-prod/aws-exports";
import "../node_modules/video-react/dist/video-react.css";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

// let amplifyConfiguration = process.env.REACT_APP_ENV === 'production' ? prodConfig : devConfig
let amplifyConfiguration = prodConfig;

Amplify.configure(amplifyConfiguration);
// console.log(process.env);
const theme = createMuiTheme({
  typography: { useNextVariants: true },
  palette: {
    primary: {
      main: "#51A882",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#EB6D80",
      contrastText: "#ffffff"
    }
  },
  overrides: {
    MuiButton: {
      label: {
        textTransform: "none"
      }
    }
  }
});

const Application = (
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>
);

ReactDOM.render(Application, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
